/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const CLASS_INVALID_CHIP = `invalid-chip`;
